module.exports = __webpack_public_path__ + "static/media/69.e0df74c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/69.jpg
// module id = 628
// module chunks = 0